import React, { FC } from "react";
import { SwitchStyled } from "./elements";
import { CheckOutlined } from "@ant-design/icons";

type SwitchProps = {
  onChange?: (e: any) => void;
  onClick?: (e: any) => void;
  defaultChecked?: boolean;
  checked?: boolean;
};

const Switch: FC<SwitchProps> = (props) => {
  return <SwitchStyled checkedChildren={<CheckOutlined />} {...props} />;
};

export default Switch;
